module.exports = __webpack_public_path__ + "static/img/15.9be8ab9.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/5/1/zh/15.png
// module id = fKDQ
// module chunks = 0